import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Combos/getComboRazaGranja`, method: 'POST', body: values, token: token})
}
